import React, { useContext, useEffect, useMemo, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import Axios from "../../_services/caller.service";
import stylesCalib from "./Calibration.module.scss";

import { useCabineContext } from "../../context/CabineContext";
import NavContext from "../../context/NavContext";
// import { useUserInviteContext } from "../../context/UserInviteContext"; // (pas utilisé ici)

import microears from "../../pics/ears.png";
import umik1 from "../../pics/umik1.png";

import { motion } from "framer-motion";
import { animatePage } from "../../animation/animationPage";

import CalibrationArray from "./certificatDownload/CalibrationArray";
import useModal from "../../hooks/useModal";
import RightDrawer from "components/Rightpanel/RightDrawer";
const DEFAULT_VISIBLE = 3;

const Calibration = () => {
  const { t } = useTranslation();

  const { ownerId, realOwnerId } = useContext(NavContext);
  // const { inviteId, userInvite } = useUserInviteContext(); // (pas utilisé)
  const { cabine } = useCabineContext();

  const [cabineWithCalib, setCabineWithCalib] = useState([]);
  const [cabineAuthToGetCerticat, setCabineAuthToGetCerticat] = useState([]);
  const [ownerRole, setOwnerRole] = useState(false);

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const { isShowing, toggle } = useModal();

  // ✅ Drawer state
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerSearch, setDrawerSearch] = useState("");

  const verifyIfDataCalibIsInCabine = useCallback(
    async (cabinesList) => {
      if (!Array.isArray(cabinesList) || cabinesList.length === 0) {
        setCabineWithCalib([]);
        return;
      }

      // 1 seul appel batch au lieu de N appels /calibrationGeneral/:id
      try {
        const cabIds = cabinesList.map((c) => c.id);
        const response = await Axios.post(`/calibrationDaysBatch`, { cabIds });
        const data = response?.data?.data ?? [];
        const withData = data
          .filter((c) => c.hasCalibrationGeneral)
          .map((c) => c.id);
        setCabineWithCalib(withData);
      } catch (e) {
        console.log(e);
        setCabineWithCalib([]);
      }
    },
    []
  );

  useEffect(() => {
    const userCabine = ownerId != null ? ownerId : realOwnerId;
    if (!userCabine) return;

    Axios.get(`/cabinesCenter/${userCabine}`)
      .then((response) => {
        const rows = response?.data?.data ?? [];
        setCabineAuthToGetCerticat(rows.map((cab) => cab.cabid));

        const roles = rows.map((cab) => cab.role).filter(Boolean);
        const isOwner =
          roles.includes("OWNER") || roles.includes("owner") || roles.includes("Owner");
        setOwnerRole(isOwner);
      })
      .catch((e) => console.log(e));
  }, [ownerId, realOwnerId]);

  useEffect(() => {
    verifyIfDataCalibIsInCabine(cabine);
  }, [cabine, verifyIfDataCalibIsInCabine]);

  const generatePdfBack = useCallback(
    (cabId, cabname) => {
      Axios.post(
        `/generatePdf/${cabId}`,
        { sendByMail: false, pdfVersion: 2 },
        { responseType: "blob" }
      )
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Certificat_Calibration_${cabname}_${cabId}.pdf`);

          document.body.appendChild(link);
          link.click();

          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          console.error("Erreur lors du téléchargement du PDF :", err);
          setError(true);
          setTimeout(() => setError(false), 1500);
        });
    },
    []
  );

  /**
   * ✅ Liste "autorisée" + "avec calibration"
   * (sans la recherche: la recherche du drawer est locale)
   */
  const allAllowedCabines = useMemo(() => {
    if (!Array.isArray(cabine) || cabine.length === 0) return [];

    return cabine
      .filter((cab) => {
        if (ownerRole) return true;
        return cabineAuthToGetCerticat.includes(cab.id);
      })
      .sort((a, b) => (a?.cabname ?? "").localeCompare(b?.cabname ?? ""));
  }, [cabine, ownerRole, cabineAuthToGetCerticat]);

  const visibleCertifs = useMemo(() => {
    return allAllowedCabines.slice(0, DEFAULT_VISIBLE);
  }, [allAllowedCabines]);

  const remainingCount = Math.max(allAllowedCabines.length - DEFAULT_VISIBLE, 0);

  /**
   * ✅ Contenu du drawer: search + liste filtrée
   * (la search ne pollue plus ta logique principale)
   */
  const drawerFiltered = useMemo(() => {
    const q = (drawerSearch || "").toLowerCase().trim();
    if (!q) return allAllowedCabines;
    return allAllowedCabines.filter((cab) =>
      (cab.cabname || "").toLowerCase().includes(q)
    );
  }, [allAllowedCabines, drawerSearch]);

  const openDrawer = () => {
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
    // optionnel: reset la search quand tu fermes
    // setDrawerSearch("");
  };

  return (
    <>
      <motion.div
        className={stylesCalib.containerPageCalibration}
        variants={animatePage}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <img className={stylesCalib.umik} src={umik1} alt="" />
        <img src={microears} alt="" className={stylesCalib.ears} />

        <div className={stylesCalib.containerCalibration}>
          <div className={stylesCalib.headerRow}>
            <h3>{t("calibration.my_certificates")}</h3>
          </div>

          {Array.isArray(cabine) && allAllowedCabines.length >= 1 && (
            <div className={stylesCalib.certifsSection}>
              <div className={stylesCalib.certifsList}>
                {visibleCertifs.map((cab) => (
                  <CalibrationArray
                    key={cab.id}
                    cab={cab}
                    cabine={cabine}
                    cabname={cab.cabname}
                    hasCalibData={cabineWithCalib.includes(cab.id)}
                    onPressBack={() => generatePdfBack(cab.id, cab.cabname)}
                    toggle={toggle}
                    isShowing={isShowing}
                    error={error}
                    success={success}
                  />
                ))}
              </div>

              {remainingCount > 0 && (
                <div className={stylesCalib.moreWrapper}>
                  <div className={stylesCalib.moreHint}>
                    {t("calibration.more_hint", { count: remainingCount })}
                  </div>

                  <button
                    type="button"
                    className={stylesCalib.moreBtn}
                    onClick={openDrawer}
                  >
                    {t("calibration.show_more")}
                  </button>
                </div>
              )}
            </div>
          )}

          {allAllowedCabines.length === 0 && (
            <h1 style={{ textAlign: "center", marginTop: "15px" }}>
              {t("calibration.no_certificates")}
            </h1>
          )}

        </div>
      </motion.div>

      {/* ✅ Drawer “modal à droite” */}
      <RightDrawer
        isOpen={drawerOpen}
        onClose={closeDrawer}
        title={t("calibration.drawer_title", { count: drawerFiltered.length })}
        width="680px"
      >
        <div className={stylesCalib.panelContent}>
          <div className={stylesCalib.panelHeader}>
            <input
              className={stylesCalib.panelSearch}
              placeholder={t("calibration.search_placeholder")}
              value={drawerSearch}
              onChange={(e) => setDrawerSearch(e.target.value)}
            />
          </div>

          <div className={stylesCalib.panelList}>
            {drawerFiltered.map((cab) => (
              <CalibrationArray
                key={cab.id}
                cab={cab}
                cabine={cabine}
                cabname={cab.cabname}
                hasCalibData={cabineWithCalib.includes(cab.id)}
                onPressBack={() => generatePdfBack(cab.id, cab.cabname)}
                toggle={toggle}
                isShowing={isShowing}
                error={error}
                success={success}
              />
            ))}
          </div>
        </div>
      </RightDrawer>
    </>
  );
};

export default Calibration;
